import React from "react";
import "./styles.css";

export const PoolUpdated = () => <span className={"badge badge-custom badge-updated"}>Pool updated</span>;
export const PoolRestaurantsUpdated = () => <span className={"badge badge-custom badge-updated"}>Pool restaurants updated</span>;
export const PoolShiftsUpdated = () => <span className={"badge badge-custom badge-updated"}>Pool shifts updated</span>;
export const PickupChanged = () => <span className={"badge badge-custom badge-warning"}>Pickup changed</span>;
export const PoolAvailabilityOverrideChanged = () => <span className={"badge badge-custom badge-availabilityoverride"}>Availability override</span>;
export const Online = () => <span className={"badge badge-custom badge-status badge-online"}>Online</span>;
export const Offline = () => <span className={"badge badge-custom badge-status badge-offline"}>Offline</span>;
export const Inactive = () => <span className={"badge badge-custom badge-status badge-inactive"}>Inactive</span>;
export const TempOffline = () => <span className={"badge badge-custom badge-tempoffline"}>Temp Offline</span>;
export const Unknown = () => <span className={"badge badge-custom badge-unknown"}>Unknown</span>;
export const DeliveryHoursUpdated = () => <span className={"badge badge-custom badge-offline"}>Delivery Hours Updated</span>;
export const RestaurantPPETAUpdated = () => <span className={"badge badge-custom badge-availabilityoverride"}>PPETA Updated</span>;
export const PoolRiskLevelChanged = () => <span className={"badge badge-custom badge-availabilityoverride"}>Pool risk level changed</span>;
export const Threshold = () => <span className={"badge badge-custom badge-updated"}>Threshold</span>;



// WEBPACK FOOTER //
// ./src/components/badges/index.js